'use client';

import { CatHeading } from 'components/blocks-components';
import { useBreakpoint } from 'components/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { getFamilyName } from 'services/equipment/utils';

export const SelectedEquipmentInfoEdit = ({
  currentEquipment
}: {
  currentEquipment: {
    productId?: string;
    model: string;
    equipmentFamily: string;
    serialNumber: string;
    assetId?: string;
    assetName?: string;
    name?: string;
  };
}) => {
  const { assetId, assetName, productId } = currentEquipment;
  const isSmallViewport = !useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_SM + 1);
  const equipmentNickname =assetId ?? assetName ?? productId;

  const name = getFamilyName(
    currentEquipment.model,
    currentEquipment.name || currentEquipment.equipmentFamily
  );

  return (
    <>
      <CatHeading variant={isSmallViewport ? 'title-sm' : 'title'}>
        {equipmentNickname}
      </CatHeading>
      <CatHeading variant={!equipmentNickname ? 'title-sm' : 'footnote'}>
        <>
          {currentEquipment?.name ? (
            <> {currentEquipment.name}</>
          ) : (
            <>
              {`${currentEquipment.model}`} -{' '}
              <span className="text-capitalize">{name?.toLowerCase()}</span>
            </>
          )}
        </>
      </CatHeading>
      <CatHeading variant="footnote">
        {currentEquipment.serialNumber}
      </CatHeading>
    </>
  );
};
